import { ModalContext } from "contexts/ModalContext";
import React, { useContext, useEffect, useState } from "react";
import { TbMessage2, TbSettings } from "react-icons/tb";
import { HiChevronDown } from "react-icons/hi2";
import useConfigPanel from "utils/hooks/useConfigPanel";
import Prompts from "views/company_settings/components/Prompts";
import ConfigPanelPostTypesOptions from "./ConfigPanelPostTypesOptions";
import { CompanyPromptsContext } from "contexts/CompanyPromptsContext";

const { Dropdown, Tooltip, Dialog } = require("components/ui");

const ConfigPanelPostTypes = React.forwardRef((props, ref) => {

    const {
        postType,
        setPostType,
        template = "",
        className = "",
        parentClassName = "",
        menuClassName = "",
        placement = "bottom-start",
        renderTitle = undefined,
        hideChecks = false,
        selectedPrompts = [],
        onSelectPrompt = undefined
    } = props;
    const { postTypes } = useConfigPanel(template, postType);
    const { prompts } = useContext(CompanyPromptsContext);
    const [isOpened, setIsOpened] = useState(false);

    return (
        <>
            <Dropdown
                menuClass={`max-h-[350px] w-[190px] overflow-y-auto !rounded-2xl !border-0 !p-0 ${menuClassName}`}
                placement={placement}
                parentClassName={parentClassName}
                ref={ref}
                renderTitle={renderTitle || 
                    <div className={`shrink-0 cursor-pointer w-full !pl-5 overflow-hidden whitespace-nowrap !pr-5 !py-3 !h-auto bg-gray-50 dark:bg-gray-600 rounded-2xl flex !justify-between gap-2 items-center font-semibold ${className}`} >
                        <div className="flex items-center gap-2">
                            {postTypes?.filter(e => e.value == postType)?.[0]?.emoji 
                                ? <>{postTypes?.filter(e => e.value == postType)?.[0]?.emoji}&nbsp;</> 
                                : ``
                            } 
                            {postTypes?.filter(e => e.value == postType)?.[0]?.name || postTypes?.[0]?.name}

                            {!!onSelectPrompt && 
                                <Tooltip wrapperClass="shrink-0" title="Prompts/Style configuration">
                                    <TbMessage2 
                                        onClick={(e) => { 
                                            e.stopPropagation(); 
                                            setIsOpened(true) 
                                        }} 
                                        className="text-lg ml-1" 
                                    />
                                </Tooltip>
                            }
                        </div>
                        <HiChevronDown className="text-sm opacity-60" />
                    </div>
                }
            >
                <ConfigPanelPostTypesOptions 
                    postType={postType}
                    setPostType={setPostType}
                    hideChecks={hideChecks}
                />
            </Dropdown>
            <Dialog 
                isOpen={isOpened} 
                onClose={() => setIsOpened(false)} 
                onRequestClose={() => setIsOpened(false)} 
                closeButtonClassName={true} 
                overlayClassName="flex items-center justify-center" 
                contentClassName="!p-0"
                width={720} 
                closable={true}
            >
                <Prompts 
                    prompts={prompts.filter(p => p.social_network_type === postType)}
                    network={postType}
                    selectable={true} 
                    selected={!!selectedPrompts?.length 
                        ? selectedPrompts 
                        : prompts.filter(p => p.social_network_type === postType && p.default)
                    }
                    isModal={true}
                    onSelect={(prompt) => onSelectPrompt(prompt)}
                    onConfirm={() => setIsOpened(false)}
                    onClose={() => setIsOpened(false)}
                />
            </Dialog>
        </>
    );
});

export default ConfigPanelPostTypes;